export const EXPERTISES_PAGES = [
  {
    slug: "expertises",
    fr: {
      eyebrow: "Expertises",
      title: "Sept piliers d'excellence stratégique",
      intro:
        "Du conseil en capital privé à l'intelligence de marché : une plateforme intégrée pour toute la complexité de l'investissement immobilier et patrimonial, entre Suisse et les marchés internationaux.",
      chips: ["7 domaines d'expertise", "28+ sous-capacités", "Approche transfrontalière", "Modèle de livraison intégré"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "L'amplitude compte. L'intégration compte davantage.",
          paragraphs: [
            "Les mandats complexes ne tiennent jamais dans une seule catégorie de conseil. Une décision d'acquisition immobilière peut déclencher un travail de structuration, une analyse réglementaire, un montage financier et une refonte de la gouvernance — simultanément.",
            "Columbus Management Consulting GmbH est organisée pour gérer ce chevauchement. Nos expertises sont volontairement interconnectées, pour que chaque client passe du diagnostic à la structuration puis à l'exécution sans perdre ni le fil ni le contexte entre les intervenants.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Ce que nous faisons",
          items: [
            { title: "Conseil en capital privé", desc: "Conseil sur mesure pour investisseurs privés, family offices et gestionnaires de fortune." },
            { title: "Origination & exécution", desc: "Origination, structuration et exécution de bout en bout de transactions transfrontalières." },
            { title: "Opérations & structuration", desc: "Architecture sociétaire et conception opérationnelle au service de l'efficacité globale." },
            { title: "Réglementaire & conformité", desc: "Navigation sereine dans des environnements réglementaires multi-juridictionnels." },
            { title: "Communication investisseurs", desc: "Communications structurées et efficaces pour investisseurs institutionnels et privés." },
            { title: "Intelligence de marché", desc: "Recherche propriétaire et analyse qui éclairent de meilleures décisions." },
            { title: "Conseil stratégique", desc: "Conseil expert pour identifier les opportunités et mettre en œuvre des stratégies transformatrices." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Découvrir. Structurer. Exécuter. Pérenniser.",
          items: [
            { title: "Découvrir", desc: "Immersion dans vos objectifs, vos contraintes et votre contexte de marché — sans aucun à-priori." },
            { title: "Structurer", desc: "Conception de l'approche optimale — juridique, financière et opérationnelle — pour votre situation." },
            { title: "Exécuter", desc: "Mise en œuvre concrète, avec un responsable identifiable à chaque étape du mandat." },
            { title: "Pérenniser", desc: "Suivi post-transaction, reporting et conseil continu pour protéger et accroître les résultats." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise",
      title: "Seven pillars of strategic excellence",
      intro:
        "From private capital advisory to market intelligence: an integrated platform for the full complexity of real estate and wealth investment, across Switzerland and international markets.",
      chips: ["7 capability areas", "28+ sub-capabilities", "Cross-border focus", "Integrated delivery"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Breadth matters. Integration matters more.",
          paragraphs: [
            "Complex mandates never fit a single advisory category. A property acquisition can trigger structuring work, regulatory analysis, financing design and governance redesign — all at once.",
            "Columbus Management Consulting GmbH is organised for that overlap. Our capabilities are deliberately interconnected, so clients move from diagnosis to structuring to execution without losing momentum or context between workstreams.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "What we do",
          items: [
            { title: "Private capital advisory", desc: "Bespoke advisory for private investors, family offices and wealth managers." },
            { title: "Deal origination & execution", desc: "End-to-end origination, structuring and execution of cross-border transactions." },
            { title: "Operations & structuring", desc: "Corporate architecture and operational design for global efficiency." },
            { title: "Regulatory & compliance", desc: "Confident navigation of multi-jurisdictional regulatory environments." },
            { title: "Investor communications", desc: "Structured, effective communications for institutional and private investors." },
            { title: "Market intelligence", desc: "Proprietary research and analysis that powers better decisions." },
            { title: "Strategic consulting", desc: "Expert consulting to identify opportunities and implement transformative strategies." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Discover. Structure. Execute. Sustain.",
          items: [
            { title: "Discover", desc: "Deep-dive into your objectives, constraints and market context — with no assumptions." },
            { title: "Structure", desc: "Design of the optimal approach — legal, financial and operational — for your situation." },
            { title: "Execute", desc: "Hands-on implementation with clear accountability at every stage of the engagement." },
            { title: "Sustain", desc: "Post-completion monitoring, reporting and ongoing advisory to protect and grow outcomes." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen",
      title: "Sieben Säulen strategischer Exzellenz",
      intro:
        "Von der Private-Capital-Beratung bis zur Marktintelligenz: eine integrierte Plattform für die gesamte Komplexität von Immobilien- und Vermögensinvestitionen — in der Schweiz und auf internationalen Märkten.",
      chips: ["7 Kompetenzbereiche", "28+ Unterkapazitäten", "Grenzüberschreitender Fokus", "Integrierte Umsetzung"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Breite zählt. Integration zählt mehr.",
          paragraphs: [
            "Komplexe Mandate passen nie in eine einzige Beratungskategorie. Ein Immobilienerwerb kann Strukturierungsarbeit, regulatorische Analyse, Finanzierungsdesign und Governance-Neugestaltung auslösen — gleichzeitig.",
            "Die Columbus Management Consulting GmbH ist für genau diese Überschneidung organisiert. Unsere Expertisen sind bewusst miteinander verknüpft, damit Kunden von der Diagnose über die Strukturierung bis zur Ausführung gelangen, ohne Faden oder Kontext zwischen den Arbeitspaketen zu verlieren.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Was wir tun",
          items: [
            { title: "Private-Capital-Beratung", desc: "Massgeschneiderte Beratung für Privatinvestoren, Family Offices und Vermögensverwalter." },
            { title: "Deal-Origination & Execution", desc: "Durchgängige Origination, Strukturierung und Ausführung grenzüberschreitender Transaktionen." },
            { title: "Operations & Strukturierung", desc: "Gesellschaftsarchitektur und operatives Design für globale Effizienz." },
            { title: "Regulierung & Compliance", desc: "Sichere Navigation in multi-jurisdiktionellen regulatorischen Umgebungen." },
            { title: "Investorenkommunikation", desc: "Strukturierte, wirksame Kommunikation für institutionelle und private Investoren." },
            { title: "Marktintelligenz", desc: "Eigenes Research und Analysen für bessere Entscheidungen." },
            { title: "Strategische Beratung", desc: "Expertenberatung zur Erkennung von Chancen und Umsetzung transformativer Strategien." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Entdecken. Strukturieren. Ausführen. Nachhalten.",
          items: [
            { title: "Entdecken", desc: "Vertiefung in Ihre Ziele, Rahmenbedingungen und Ihren Marktkontext — ohne Vorannahmen." },
            { title: "Strukturieren", desc: "Gestaltung des optimalen Ansatzes — rechtlich, finanziell und operativ — für Ihre Situation." },
            { title: "Ausführen", desc: "Praktische Umsetzung mit klarer Verantwortlichkeit in jeder Phase des Mandats." },
            { title: "Nachhalten", desc: "Monitoring nach Abschluss, Reporting und laufende Beratung zum Schutz und Ausbau der Ergebnisse." },
          ],
        },
      ],
    },
  },
  {
    slug: "expertises/conseil-capital-prive",
    fr: {
      eyebrow: "Expertises · Capital privé",
      title: "Conseil en capital privé",
      intro:
        "L'infrastructure de conseil que les institutions considèrent comme acquise — adaptée au capital privé. Structures d'investissement sur mesure, préservation et transmission de patrimoine.",
      chips: ["Solutions de portefeuille", "Infrastructure family office", "Planification de succession", "Investissements alternatifs", "Planification patrimoniale", "Accès aux deals privés"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Des structures pensées pour le capital privé",
          items: [
            { title: "Structures d'investissement transfrontalières", desc: "Architectures sur mesure combinant entités suisses et européennes pour vos actifs immobiliers et financiers." },
            { title: "Accès aux transactions & co-investissement", desc: "Accès privilégié à des opportunités hors marché et à des tours de co-investissement sélectionnés." },
            { title: "Architecture de portefeuille multi-juridictions", desc: "Consolidation et pilotage d'actifs répartis sur plusieurs pays, devises et cadres fiscaux." },
            { title: "Préservation & succession", desc: "Stratégies de détention, gouvernance familiale et transmission multigénérationnelle du patrimoine." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Chaque structure que nous recommandons est une structure que nous accepterions pour notre propre patrimoine. »",
          author: "Columbus Management Consulting GmbH — Principe fondateur",
        },
        {
          type: "numbered",
          theme: "light",
          title: "Comment un mandat avance",
          items: [
            { title: "Cadrage confidentiel", desc: "Une première discussion pour comprendre objectifs, horizon, contraintes fiscales et appétence au risque." },
            { title: "Architecture proposée", desc: "Une structure écrite, chiffrée et expliquée — véhicules, juridictions, gouvernance et calendrier." },
            { title: "Mise en place coordonnée", desc: "Coordination des notaires, fiscalistes, banques et conseils externes jusqu'à la signature." },
            { title: "Revue annuelle", desc: "Un point complet chaque année, et une alerte dès qu'un événement change l'équation." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Private capital",
      title: "Private capital advisory",
      intro:
        "The advisory infrastructure institutional clients take for granted — tailored for private capital. Bespoke investment structures, wealth preservation and succession.",
      chips: ["Portfolio solutions", "Family office infrastructure", "Succession planning", "Alternative investments", "Wealth planning", "Private deal access"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Structures designed for private capital",
          items: [
            { title: "Cross-border investment structures", desc: "Bespoke architectures combining Swiss and European entities for real estate and financial assets." },
            { title: "Deal access & co-investment", desc: "Privileged access to off-market opportunities and selected co-investment rounds." },
            { title: "Multi-jurisdiction portfolio architecture", desc: "Consolidation and steering of assets spread across countries, currencies and tax regimes." },
            { title: "Preservation & succession", desc: "Holding strategies, family governance and multigenerational wealth transfer." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "\u00AB Every structure we recommend is one we would accept for our own wealth. \u00BB",
          author: "Columbus Management Consulting GmbH — Founding principle",
        },
        {
          type: "numbered",
          theme: "light",
          title: "How a mandate moves forward",
          items: [
            { title: "Confidential scoping", desc: "A first discussion to understand objectives, horizon, tax constraints and risk appetite." },
            { title: "Proposed architecture", desc: "A written, quantified, explained structure — vehicles, jurisdictions, governance and timeline." },
            { title: "Coordinated implementation", desc: "Coordination of notaries, tax advisers, banks and external counsel through to signature." },
            { title: "Annual review", desc: "A full review every year, and an alert the moment an event changes the equation." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Privatkapital",
      title: "Private-Capital-Beratung",
      intro:
        "Die Beratungsinfrastruktur, die institutionelle Kunden als selbstverständlich betrachten — zugeschnitten auf Privatkapital. Massgeschneiderte Investmentstrukturen, Vermögenserhalt und Nachfolge.",
      chips: ["Portfolio-Lösungen", "Family-Office-Infrastruktur", "Nachfolgeplanung", "Alternative Anlagen", "Vermögensplanung", "Zugang zu privaten Deals"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Strukturen, gedacht für Privatkapital",
          items: [
            { title: "Grenzüberschreitende Investmentstrukturen", desc: "Massgeschneiderte Architekturen mit Schweizer und europäischen Gesellschaften für Immobilien- und Finanzanlagen." },
            { title: "Deal-Zugang & Co-Investition", desc: "Privilegierter Zugang zu Off-Market-Gelegenheiten und ausgewählten Co-Investitionsrunden." },
            { title: "Portfolio-Architektur über Jurisdiktionen", desc: "Konsolidierung und Steuerung von Vermögenswerten über Länder, Währungen und Steuerregime hinweg." },
            { title: "Erhalt & Nachfolge", desc: "Haltestrategien, Family Governance und mehrgenerationelle Vermögensübertragung." },
          ],
        },
        {
          type: "quote",
          theme: "dark",
          text: "« Jede Struktur, die wir empfehlen, ist eine, die wir auch für unser eigenes Vermögen akzeptieren würden. »",
          author: "Columbus Management Consulting GmbH — Gründungsprinzip",
        },
        {
          type: "numbered",
          theme: "light",
          title: "Wie ein Mandat voranschreitet",
          items: [
            { title: "Vertrauliche Abklärung", desc: "Ein erstes Gespräch zu Zielen, Horizont, steuerlichen Rahmenbedingungen und Risikobereitschaft." },
            { title: "Vorgeschlagene Architektur", desc: "Eine schriftliche, bezifferte, erklärte Struktur — Vehikel, Jurisdiktionen, Governance und Zeitplan." },
            { title: "Koordinierte Umsetzung", desc: "Koordination von Notaren, Steuerberatern, Banken und externen Beratern bis zur Unterschrift." },
            { title: "Jährliches Review", desc: "Eine vollständige Überprüfung jedes Jahr — und eine Warnung, sobald ein Ereignis die Lage ändert." },
          ],
        },
      ],
    },
  },
  {
    slug: "expertises/origination-execution",
    fr: {
      eyebrow: "Expertises · Transactions",
      title: "Origination & exécution de transactions",
      intro:
        "De la première approche à la signature chez le notaire : origination, diligence et exécution de transactions immobilières et d'entreprises, sur plusieurs juridictions.",
      chips: ["Conseil M&A", "Levée de capitaux", "Entrée sur marché", "JV & partenariats", "Due diligence", "Gestion de transaction", "Évaluation"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Une exécution qui supporte le regard des parties prenantes",
          paragraphs: [
            "Une transaction réussie ne se mesure pas à la signature, mais à la solidité du dossier devant les banques, les conseils, les actionnaires et les autorités. Nous préparons chaque mandat pour ce niveau d'examen.",
            "Notre équipe intervient sur l'origination, l'analyse, la négociation et la coordination de clôture — avec une documentation pensée pour circuler entre conseil d'administration, investisseurs et conseils externes.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Domaines d'intervention",
          items: [
            { title: "Conseil M&A", desc: "Accompagnement achat et cession : ciblage, valorisation, négociation et structuration de l'opération." },
            { title: "Levée de capitaux", desc: "Positionnement investisseur, documentation et coordination des tours de financement." },
            { title: "Entrée sur marché", desc: "Exécution d'implantation sur de nouveaux territoires : structure, partenaires et calendrier." },
            { title: "Due diligence", desc: "Examen financier, juridique, fiscal et opérationnel — y compris la diligence immobilière complète." },
            { title: "Gestion de transaction", desc: "Pilotage du calendrier, des conditions suspensives et des interlocuteurs jusqu'au closing." },
            { title: "Évaluation", desc: "Valorisation d'actifs et d'entreprises, appuyée sur des références de marché documentées." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Le déroulé d'une transaction",
          items: [
            { title: "Screening initial", desc: "Examen de l'opportunité par un conseiller senior : cohérence, prix, risques et calendrier." },
            { title: "Analyse approfondie", desc: "Recherche documentée sur l'actif, le vendeur, le marché et le cadre juridique." },
            { title: "Revue de comité", desc: "Évaluation collégiale des rendements ajustés au risque avant tout engagement." },
            { title: "Exécution", desc: "Clôture rapide, transparente, avec reporting à chaque étape décisive." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Transactions",
      title: "Deal origination & execution",
      intro:
        "From first approach to signature at the notary: origination, diligence and execution of real estate and corporate transactions across jurisdictions.",
      chips: ["M&A advisory", "Capital raise", "Market entry", "JV & partnerships", "Due diligence", "Transaction management", "Valuation"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Execution that withstands stakeholder scrutiny",
          paragraphs: [
            "A successful transaction is not measured at signature, but by how the file holds up before banks, counsel, shareholders and authorities. We prepare every mandate for that level of review.",
            "Our team covers origination, analysis, negotiation and closing coordination — with documentation designed to travel between boards, investors and external advisers.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Areas of work",
          items: [
            { title: "M&A advisory", desc: "Buy-side and sell-side support: targeting, valuation, negotiation and deal structuring." },
            { title: "Capital raise", desc: "Investor positioning, documentation and coordination of financing rounds." },
            { title: "Market entry execution", desc: "Implementation of new-market entry: structure, partners and timeline." },
            { title: "Due diligence", desc: "Financial, legal, tax and operational review — including full real estate diligence." },
            { title: "Transaction management", desc: "Steering of timetable, conditions precedent and counterparties through to closing." },
            { title: "Valuation", desc: "Asset and company valuation backed by documented market references." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "The course of a transaction",
          items: [
            { title: "Initial screening", desc: "A senior advisor reviews the opportunity: coherence, pricing, risks and timetable." },
            { title: "Deep analysis", desc: "Documented research on the asset, the seller, the market and the legal framework." },
            { title: "Committee review", desc: "Collegiate assessment of risk-adjusted returns before any commitment." },
            { title: "Execution", desc: "Fast, transparent closing with reporting at every decisive step." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Transaktionen",
      title: "Deal-Origination & Execution",
      intro:
        "Vom ersten Kontakt bis zur Unterschrift beim Notar: Origination, Prüfung und Ausführung von Immobilien- und Unternehmenstransaktionen über Jurisdiktionen hinweg.",
      chips: ["M&A-Beratung", "Kapitalbeschaffung", "Markteintritt", "JV & Partnerschaften", "Due Diligence", "Transaktionsmanagement", "Bewertung"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Ausführung, die der Prüfung durch Stakeholder standhält",
          paragraphs: [
            "Eine erfolgreiche Transaktion misst sich nicht an der Unterschrift, sondern daran, wie das Dossier vor Banken, Beratern, Aktionären und Behörden besteht. Wir bereiten jedes Mandat auf genau diese Prüfung vor.",
            "Unser Team deckt Origination, Analyse, Verhandlung und Abschlusskoordination ab — mit einer Dokumentation, die zwischen Verwaltungsrat, Investoren und externen Beratern zirkulieren kann.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Arbeitsbereiche",
          items: [
            { title: "M&A-Beratung", desc: "Kauf- und Verkaufsseite: Zielidentifikation, Bewertung, Verhandlung und Deal-Strukturierung." },
            { title: "Kapitalbeschaffung", desc: "Investorenpositionierung, Dokumentation und Koordination von Finanzierungsrunden." },
            { title: "Markteintritt", desc: "Umsetzung des Eintritts in neue Märkte: Struktur, Partner und Zeitplan." },
            { title: "Due Diligence", desc: "Finanzielle, rechtliche, steuerliche und operative Prüfung — inklusive vollständiger Immobilien-Diligence." },
            { title: "Transaktionsmanagement", desc: "Steuerung von Zeitplan, aufschiebenden Bedingungen und Gesprächspartnern bis zum Closing." },
            { title: "Bewertung", desc: "Bewertung von Vermögenswerten und Unternehmen, gestützt auf dokumentierte Marktreferenzen." },
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Der Ablauf einer Transaktion",
          items: [
            { title: "Erstes Screening", desc: "Prüfung der Gelegenheit durch einen Senior-Berater: Kohärenz, Preis, Risiken und Zeitplan." },
            { title: "Vertiefte Analyse", desc: "Dokumentiertes Research zu Objekt, Verkäufer, Markt und rechtlichem Rahmen." },
            { title: "Komitee-Review", desc: "Kollegiale Bewertung der risikoadjustierten Renditen vor jedem Engagement." },
            { title: "Ausführung", desc: "Schneller, transparenter Abschluss mit Reporting bei jedem entscheidenden Schritt." },
          ],
        },
      ],
    },
  },
  {
    slug: "expertises/operations-structuration",
    fr: {
      eyebrow: "Expertises · Structuration",
      title: "Opérations & structuration",
      intro:
        "L'architecture sociétaire et opérationnelle qui rend un patrimoine efficace : holdings, SPV, gouvernance, trésorerie et coordination fiduciaire.",
      chips: ["Structuration sociétaire", "Véhicules SPV", "Post-transaction", "Cadres de gouvernance", "Gestion de trésorerie", "Finance & comptabilité", "Trust & conservation"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "La structure est une décision d'investissement",
          paragraphs: [
            "Une bonne structure réduit la charge fiscale, clarifie la gouvernance, protège les associés et facilite la transmission. Une mauvaise fait l'inverse — silencieusement, pendant des années.",
            "Nous concevons des architectures de détention adaptées à chaque situation : sociétés holding, SPV par actif, pactes d'associés et règles de décision écrites avant que les émotions ne s'en mêlent.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Ce que nous structurons",
          items: [
            { title: "Holdings & chaînes de détention", desc: "Architecture suisse ou mixte, alignée sur la résidence fiscale et les objectifs de transmission." },
            { title: "SPV & véhicules d'investissement", desc: "Véhicules dédiés par actif ou par projet, avec documentation et gouvernance propres." },
            { title: "Cadres de gouvernance", desc: "Droits de décision, comités, reporting et rythme d'oversight pensés pour durer." },
            { title: "Intégration post-transaction", desc: "Reprise des contrats, des équipes et des processus après une acquisition." },
            { title: "Trésorerie & finance", desc: "Organisation des flux, comptabilité et reporting financier fiables." },
            { title: "Trust & conservation", desc: "Coordination avec trustees et dépositaires pour la protection des actifs." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Une structure bien dessinée ne se remarque pas. Elle fonctionne, année après année. »",
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Structuring",
      title: "Operations & structuring",
      intro:
        "The corporate and operational architecture that makes wealth efficient: holdings, SPVs, governance, treasury and fiduciary coordination.",
      chips: ["Corporate structuring", "SPV vehicles", "Post-transaction", "Governance frameworks", "Treasury management", "Finance & accounting", "Trust & custody"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Structure is an investment decision",
          paragraphs: [
            "A good structure reduces tax friction, clarifies governance, protects partners and eases succession. A bad one does the opposite — quietly, for years.",
            "We design holding architectures adapted to each situation: holding companies, per-asset SPVs, shareholder agreements and written decision rules — before emotions get involved.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "What we structure",
          items: [
            { title: "Holdings & ownership chains", desc: "Swiss or mixed architecture, aligned with tax residence and succession goals." },
            { title: "SPVs & investment vehicles", desc: "Dedicated vehicles per asset or project, with their own documentation and governance." },
            { title: "Governance frameworks", desc: "Decision rights, committees, reporting and oversight rhythm designed to last." },
            { title: "Post-transaction integration", desc: "Takeover of contracts, teams and processes after an acquisition." },
            { title: "Treasury & finance", desc: "Organisation of cash flows, accounting and dependable financial reporting." },
            { title: "Trust & custody", desc: "Coordination with trustees and custodians for asset protection." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "\u00AB A well-designed structure goes unnoticed. It simply works, year after year. \u00BB",
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Strukturierung",
      title: "Operations & Strukturierung",
      intro:
        "Die Gesellschafts- und Betriebsarchitektur, die Vermögen effizient macht: Holdings, SPVs, Governance, Treasury und fiduziarische Koordination.",
      chips: ["Gesellschaftsstrukturierung", "SPV-Vehikel", "Post-Transaktion", "Governance-Rahmen", "Treasury-Management", "Finanzen & Rechnungswesen", "Trust & Verwahrung"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Struktur ist eine Investitionsentscheidung",
          paragraphs: [
            "Eine gute Struktur reduziert steuerliche Reibung, klärt Governance, schützt Gesellschafter und erleichtert die Nachfolge. Eine schlechte tut das Gegenteil — still, über Jahre.",
            "Wir gestalten Holding-Architekturen passend zu jeder Situation: Holdinggesellschaften, SPVs pro Aktivum, Gesellschaftervereinbarungen und schriftliche Entscheidungsregeln — bevor Emotionen ins Spiel kommen.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Was wir strukturieren",
          items: [
            { title: "Holdings & Beteiligungsketten", desc: "Schweizer oder gemischte Architektur, abgestimmt auf Steuerdomizil und Nachfolgeziele." },
            { title: "SPVs & Investmentvehikel", desc: "Dedizierte Vehikel pro Aktivum oder Projekt, mit eigener Dokumentation und Governance." },
            { title: "Governance-Rahmen", desc: "Entscheidungsrechte, Ausschüsse, Reporting und Aufsichtsrhythmus — gebaut für die Dauer." },
            { title: "Post-Transaktions-Integration", desc: "Übernahme von Verträgen, Teams und Prozessen nach einem Erwerb." },
            { title: "Treasury & Finanzen", desc: "Organisation der Geldflüsse, Buchhaltung und verlässliches Finanzreporting." },
            { title: "Trust & Verwahrung", desc: "Koordination mit Treuhändern und Verwahrstellen zum Schutz der Vermögenswerte." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Eine gut gestaltete Struktur fällt nicht auf. Sie funktioniert einfach — Jahr für Jahr. »",
        },
      ],
    },
  },
  {
    slug: "expertises/reglementaire-conformite",
    fr: {
      eyebrow: "Expertises · Conformité",
      title: "Réglementaire & conformité",
      intro:
        "Une lecture pratique de la conformité multi-juridictions : KYC complet, diligence raisonnable, reporting réglementaire et coordination des conseils — CH · LU · UE.",
      chips: ["Conformité juridictionnelle", "Reporting réglementaire", "AML / KYC", "Reporting ESG", "Réglementation des fonds"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Pratique, pas abstraite",
          paragraphs: [
            "Nous nous concentrons sur la manière dont les exigences réglementaires affectent concrètement la structure, les mouvements de capitaux, le reporting et le calendrier d'exécution de vos projets.",
            "Nous ne remplaçons pas les conseils juridiques ou fiscaux qualifiés. Nous vous aidons à poser les bonnes questions, à coordonner les spécialistes et à traduire leurs avis en décisions opérationnelles.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Notre dispositif de conformité",
          items: [
            { title: "KYC complet", desc: "Identification approfondie et vérification des antécédents avant toute relation — protection contre la fraude et le blanchiment." },
            { title: "Diligence raisonnable", desc: "Examen de l'historique financier, de la gouvernance, des sources de financement et du cadre réglementaire de chaque contrepartie." },
            { title: "Diligence immobilière", desc: "Vérification des titres de propriété, évaluation juridique et fiscale, examen des litiges et conformité environnementale." },
            { title: "Reporting & surveillance", desc: "Suivi continu des obligations, mises à jour de conformité et reporting documenté." },
            { title: "Lex Koller & LFAIE", desc: "Analyse des restrictions d'acquisition immobilière en Suisse pour les acquéreurs étrangers." },
            { title: "Cartographie des juridictions", desc: "Comparaison pragmatique des cadres CH, LU et UE avant chaque structuration." },
          ],
        },
        {
          type: "stats",
          theme: "light",
          title: "La transparence en chiffres",
          items: [
            { value: "4 % – 12 %", label: "Fourchette de commission transparente" },
            { value: "100 %", label: "Des mandats avec KYC complet" },
            { value: "nLPD · RGPD", label: "Conformité protection des données" },
            { value: "0", label: "Produit placé sans diligence complète" },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Compliance",
      title: "Regulatory & compliance",
      intro:
        "A practical reading of multi-jurisdiction compliance: full KYC, due diligence, regulatory reporting and counsel coordination — CH · LU · EU.",
      chips: ["Jurisdictional compliance", "Regulatory reporting", "AML / KYC", "ESG reporting", "Fund regulation"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Practical, not abstract",
          paragraphs: [
            "We focus on how regulatory requirements concretely affect structure, capital movements, reporting and execution timelines for your projects.",
            "We do not replace qualified legal or tax counsel. We help you frame the right questions, coordinate specialists and translate their advice into operating decisions.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Our compliance framework",
          items: [
            { title: "Full KYC", desc: "Thorough identification and background checks before any relationship — protection against fraud and money laundering." },
            { title: "Due diligence", desc: "Review of financial history, governance, funding sources and regulatory framework of every counterparty." },
            { title: "Real estate diligence", desc: "Title verification, legal and tax assessment, litigation review and environmental compliance." },
            { title: "Reporting & monitoring", desc: "Continuous tracking of obligations, compliance updates and documented reporting." },
            { title: "Lex Koller & AWG", desc: "Analysis of Swiss property acquisition restrictions for foreign buyers." },
            { title: "Jurisdiction mapping", desc: "Pragmatic comparison of CH, LU and EU frameworks before each structuring." },
          ],
        },
        {
          type: "stats",
          theme: "light",
          title: "Transparency in numbers",
          items: [
            { value: "4% – 12%", label: "Transparent commission range" },
            { value: "100%", label: "Of mandates with full KYC" },
            { value: "nFADP · GDPR", label: "Data protection compliance" },
            { value: "0", label: "Products placed without full diligence" },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Compliance",
      title: "Regulierung & Compliance",
      intro:
        "Eine praktische Lesart der multi-jurisdiktionellen Compliance: vollständiges KYC, Due Diligence, regulatorisches Reporting und Beraterkoordination — CH · LU · EU.",
      chips: ["Jurisdiktions-Compliance", "Regulatorisches Reporting", "AML / KYC", "ESG-Reporting", "Fondsregulierung"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Praktisch, nicht abstrakt",
          paragraphs: [
            "Wir konzentrieren uns darauf, wie regulatorische Anforderungen Struktur, Kapitalbewegungen, Reporting und Umsetzungszeitpläne Ihrer Projekte konkret beeinflussen.",
            "Wir ersetzen keine qualifizierten Rechts- oder Steuerberater. Wir helfen Ihnen, die richtigen Fragen zu stellen, Spezialisten zu koordinieren und deren Gutachten in operative Entscheidungen zu übersetzen.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Unser Compliance-Rahmen",
          items: [
            { title: "Vollständiges KYC", desc: "Gründliche Identifikation und Hintergrundprüfung vor jeder Beziehung — Schutz vor Betrug und Geldwäscherei." },
            { title: "Due Diligence", desc: "Prüfung von Finanzhistorie, Governance, Finanzierungsquellen und regulatorischem Rahmen jeder Gegenpartei." },
            { title: "Immobilien-Diligence", desc: "Prüfung der Eigentumstitel, rechtliche und steuerliche Bewertung, Rechtsstreitigkeiten und Umweltkonformität." },
            { title: "Reporting & Überwachung", desc: "Laufende Verfolgung der Pflichten, Compliance-Updates und dokumentiertes Reporting." },
            { title: "Lex Koller & BewG", desc: "Analyse der Schweizer Erwerbsbeschränkungen für ausländische Käufer." },
            { title: "Jurisdiktions-Mapping", desc: "Pragmatischer Vergleich der Rahmen CH, LU und EU vor jeder Strukturierung." },
          ],
        },
        {
          type: "stats",
          theme: "light",
          title: "Transparenz in Zahlen",
          items: [
            { value: "4 % – 12 %", label: "Transparente Kommissionsspanne" },
            { value: "100 %", label: "Der Mandate mit vollständigem KYC" },
            { value: "nDSG · DSGVO", label: "Datenschutzkonformität" },
            { value: "0", label: "Produkte ohne vollständige Prüfung" },
          ],
        },
      ],
    },
  },
  {
    slug: "expertises/communication-investisseurs",
    fr: {
      eyebrow: "Expertises · Communication",
      title: "Communication investisseurs",
      intro:
        "Des communications structurées qui renforcent la confiance : reporting investisseurs, assemblées, relations actionnaires et supports de décision.",
      chips: ["Reporting investisseurs", "Communication parties prenantes", "Assemblées annuelles", "Communication digitale", "Omnicanal", "Marketing & engagement"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Ce que nous mettons en place",
          items: [
            { title: "Reporting investisseurs", desc: "Rapports périodiques clairs, chiffrés et auditables, adaptés à chaque catégorie d'investisseurs." },
            { title: "Relations actionnaires", desc: "Structuration du dialogue avec actionnaires, associés et parties prenantes clés." },
            { title: "Assemblées & gouvernance", desc: "Préparation des assemblées, documents de vote et supports de décision du conseil." },
            { title: "Communication digitale", desc: "Canaux modernes et sécurisés pour informer sans alourdir." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "La qualité du reporting est un signal de gouvernance",
          paragraphs: [
            "Un investisseur bien informé reste investi. Nos supports sont préparés pour être lus par des conseils d'administration, des comités d'investissement et des family offices exigeants.",
            "Chaque rapport suit une logique simple : faits, chiffres, décisions prises, décisions à prendre. Jamais de jargon pour masquer une absence de substance.",
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Communications",
      title: "Investor communications",
      intro:
        "Structured communications that build trust: investor reporting, annual meetings, shareholder relations and decision-ready materials.",
      chips: ["Investor reporting", "Stakeholder communications", "Annual meetings", "Digital communications", "Omnichannel", "Marketing & engagement"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "What we put in place",
          items: [
            { title: "Investor reporting", desc: "Clear, quantified, auditable periodic reports tailored to each investor category." },
            { title: "Shareholder relations", desc: "Structuring of dialogue with shareholders, partners and key stakeholders." },
            { title: "Meetings & governance", desc: "Preparation of general meetings, voting documents and board decision materials." },
            { title: "Digital communications", desc: "Modern, secure channels that inform without clutter." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Reporting quality is a governance signal",
          paragraphs: [
            "A well-informed investor stays invested. Our materials are prepared to be read by boards, investment committees and demanding family offices.",
            "Every report follows a simple logic: facts, figures, decisions made, decisions to take. Never jargon to mask a lack of substance.",
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Kommunikation",
      title: "Investorenkommunikation",
      intro:
        "Strukturierte Kommunikation, die Vertrauen aufbaut: Investorenreporting, Generalversammlungen, Aktionärsbeziehungen und entscheidungsreife Unterlagen.",
      chips: ["Investorenreporting", "Stakeholder-Kommunikation", "Generalversammlungen", "Digitale Kommunikation", "Omnichannel", "Marketing & Engagement"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Was wir einrichten",
          items: [
            { title: "Investorenreporting", desc: "Klare, bezifferte, prüfbare periodische Berichte, zugeschnitten auf jede Investorenkategorie." },
            { title: "Aktionärsbeziehungen", desc: "Strukturierung des Dialogs mit Aktionären, Gesellschaftern und zentralen Stakeholdern." },
            { title: "Versammlungen & Governance", desc: "Vorbereitung von Generalversammlungen, Abstimmungsunterlagen und Entscheidungsvorlagen." },
            { title: "Digitale Kommunikation", desc: "Moderne, sichere Kanäle, die informieren, ohne zu überladen." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Reporting-Qualität ist ein Governance-Signal",
          paragraphs: [
            "Ein gut informierter Investor bleibt investiert. Unsere Unterlagen sind so aufbereitet, dass Verwaltungsräte, Investitionsausschüsse und anspruchsvolle Family Offices sie lesen können.",
            "Jeder Bericht folgt einer einfachen Logik: Fakten, Zahlen, getroffene Entscheidungen, zu treffende Entscheidungen. Nie Jargon, um fehlende Substanz zu kaschieren.",
          ],
        },
      ],
    },
  },
  {
    slug: "expertises/intelligence-marche",
    fr: {
      eyebrow: "Expertises · Recherche",
      title: "Intelligence de marché & recherche",
      intro:
        "Une recherche propriétaire qui éclaire les décisions : analyse de marchés, intelligence transactionnelle, études sectorielles et lecture des flux d'investisseurs.",
      chips: ["Études de marché", "Intelligence transactionnelle", "Analytique de portefeuille", "Rapports sectoriels", "Intelligence investisseurs", "Intelligence distribution"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Chaque recommandation commence par des preuves",
          paragraphs: [
            "Vous ne trouverez dans nos études aucune information reprise telle quelle de sources ouvertes. L'analyse de marché réalisée pour votre mandat est individuelle, documentée et entièrement dédiée à votre décision.",
            "Notre lecture couvre le marché immobilier suisse, les grandes métropoles européennes et les marchés à fort potentiel que nous suivons pour nos clients.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Nos productions de recherche",
          items: [
            { title: "Analyses de marché", desc: "Études de prix, de rendements locatifs et de dynamiques démographiques par zone." },
            { title: "Intelligence transactionnelle", desc: "Lecture des transactions comparables et des flux de capitaux avant d'engager une négociation." },
            { title: "Rapports sectoriels", desc: "Notes structurées sur les segments immobiliers et les classes d'actifs suivies." },
            { title: "Analytique de portefeuille", desc: "Mesure de performance, d'allocation et de concentration de vos actifs existants." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Les meilleures décisions reposent sur les meilleures informations — pas sur les opinions. »",
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Research",
      title: "Market intelligence & research",
      intro:
        "Proprietary research that informs decisions: market analysis, deal intelligence, sector studies and investor flow reading.",
      chips: ["Market research", "Deal intelligence", "Portfolio analytics", "Sector reports", "Investor intelligence", "Distribution intelligence"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Every recommendation starts with evidence",
          paragraphs: [
            "You will not find in our studies any information merely repeated from open sources. The market analysis produced for your mandate is individual, documented and entirely dedicated to your decision.",
            "Our coverage spans the Swiss real estate market, major European cities and the high-potential markets we monitor for clients.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Our research output",
          items: [
            { title: "Market analysis", desc: "Studies of prices, rental yields and demographic dynamics by area." },
            { title: "Deal intelligence", desc: "Reading of comparable transactions and capital flows before entering a negotiation." },
            { title: "Sector reports", desc: "Structured notes on the real estate segments and asset classes we track." },
            { title: "Portfolio analytics", desc: "Measurement of performance, allocation and concentration across your existing assets." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "\u00AB The best decisions rest on the best information — not on opinions. \u00BB",
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Research",
      title: "Marktintelligenz & Research",
      intro:
        "Eigenes Research als Entscheidungsgrundlage: Marktanalysen, Deal-Intelligenz, Sektorstudien und die Lesart der Investorenströme.",
      chips: ["Marktstudien", "Deal-Intelligenz", "Portfolio-Analytik", "Sektorberichte", "Investorenintelligenz", "Distributionsintelligenz"],
      sections: [
        {
          type: "text",
          theme: "light",
          title: "Jede Empfehlung beginnt mit Belegen",
          paragraphs: [
            "In unseren Studien finden Sie keine Informationen, die lediglich aus offenen Quellen übernommen wurden. Die Marktanalyse für Ihr Mandat ist individuell, dokumentiert und vollständig Ihrer Entscheidung gewidmet.",
            "Unsere Abdeckung umfasst die Schweizer Immobilienmärkte, die grossen europäischen Metropolen und die Wachstumsmärkte, die wir für Kunden beobachten.",
          ],
        },
        {
          type: "grid",
          theme: "dark",
          title: "Unsere Research-Produkte",
          items: [
            { title: "Marktanalysen", desc: "Studien zu Preisen, Mietrenditen und demografischen Dynamiken pro Zone." },
            { title: "Deal-Intelligenz", desc: "Lesart vergleichbarer Transaktionen und Kapitalströme vor jeder Verhandlung." },
            { title: "Sektorberichte", desc: "Strukturierte Notizen zu den Immobiliensegmenten und Anlageklassen, die wir verfolgen." },
            { title: "Portfolio-Analytik", desc: "Messung von Performance, Allokation und Konzentration Ihrer bestehenden Anlagen." },
          ],
        },
        {
          type: "quote",
          theme: "light",
          text: "« Die besten Entscheidungen beruhen auf den besten Informationen — nicht auf Meinungen. »",
        },
      ],
    },
  },
  {
    slug: "expertises/conseil-strategique",
    fr: {
      eyebrow: "Expertises · Stratégie",
      title: "Conseil stratégique",
      intro:
        "Identifier les opportunités, arbitrer les scénarios, mettre en œuvre : un conseil de direction appliqué à l'immobilier, au patrimoine et à la croissance des entreprises.",
      chips: ["Stratégie d'entreprise", "Transformation digitale", "Excellence opérationnelle", "Conseil en croissance"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Quatre terrains d'intervention",
          items: [
            { title: "Stratégie d'entreprise", desc: "Clarification des priorités, allocation du capital et feuilles de route pluriannuelles." },
            { title: "Optimisation des processus", desc: "Organisation, flux et gouvernance : gagner en fiabilité, en rapidité et en maîtrise des coûts." },
            { title: "Accompagnement des dirigeants", desc: "Conseil de proximité pour les décisions clés : croissance, financement, transformation, transmission." },
            { title: "Pilotage financier & performance", desc: "Budget, indicateurs et reporting : marges, trésorerie et objectifs sous contrôle." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Chaque mission commence par l'écoute",
          paragraphs: [
            "Elle se termine par un plan écrit, chiffré et expliqué. Vous savez toujours pourquoi chaque décision est recommandée — et ce qu'elle coûte.",
            "Nous ne plaçons jamais de produit sans raison documentée. Cette règle guide chaque mission depuis la création du cabinet.",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Notre méthode en quatre étapes",
          items: [
            { title: "Diagnostic d'activité", desc: "Audit complet et confidentiel : activité, organisation, finances, objectifs et contraintes de marché." },
            { title: "Stratégie sur mesure", desc: "Un plan d'action chiffré et expliqué, validé avec vous avant toute mise en œuvre." },
            { title: "Mise en œuvre", desc: "Exécution à vos côtés, en toute transparence sur les frais, les supports et les délais." },
            { title: "Suivi & rééquilibrage", desc: "Point annuel minimum et alertes dès qu'un événement de marché ou de vie change la donne." },
          ],
        },
      ],
    },
    en: {
      eyebrow: "Expertise · Strategy",
      title: "Strategic consulting",
      intro:
        "Identifying opportunities, arbitrating scenarios, implementing: executive consulting applied to real estate, wealth and business growth.",
      chips: ["Business strategy", "Digital transformation", "Operational excellence", "Growth advisory"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Four fields of work",
          items: [
            { title: "Business strategy", desc: "Clarifying priorities, capital allocation and multi-year roadmaps." },
            { title: "Process optimisation", desc: "Organisation, flows and governance: more reliability, speed and cost control." },
            { title: "Executive coaching", desc: "Close counsel for key decisions: growth, financing, transformation, succession." },
            { title: "Financial steering & performance", desc: "Budget, indicators and reporting: margins, cash and objectives under control." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Every engagement starts with listening",
          paragraphs: [
            "It ends with a written, quantified and explained plan. You always know why each decision is recommended — and what it costs.",
            "We never place a product without a documented reason. That rule has guided every engagement since the firm was founded.",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Our four-step method",
          items: [
            { title: "Activity diagnostic", desc: "Complete, confidential audit: activity, organisation, finances, objectives and market constraints." },
            { title: "Bespoke strategy", desc: "A quantified, explained action plan, validated with you before any implementation." },
            { title: "Implementation", desc: "Execution alongside you, in full transparency on fees, instruments and deadlines." },
            { title: "Monitoring & rebalancing", desc: "At least one annual review, and alerts the moment a market or life event changes the picture." },
          ],
        },
      ],
    },
    de: {
      eyebrow: "Expertisen · Strategie",
      title: "Strategische Beratung",
      intro:
        "Chancen erkennen, Szenarien abwägen, umsetzen: Unternehmensberatung, angewandt auf Immobilien, Vermögen und Unternehmenswachstum.",
      chips: ["Unternehmensstrategie", "Digitale Transformation", "Operative Exzellenz", "Wachstumsberatung"],
      sections: [
        {
          type: "grid",
          theme: "light",
          title: "Vier Arbeitsfelder",
          items: [
            { title: "Unternehmensstrategie", desc: "Klärung der Prioritäten, Kapitalallokation und mehrjährige Roadmaps." },
            { title: "Prozessoptimierung", desc: "Organisation, Abläufe und Governance: mehr Verlässlichkeit, Tempo und Kostenkontrolle." },
            { title: "Begleitung der Geschäftsleitung", desc: "Nahberatung für Schlüsselentscheidungen: Wachstum, Finanzierung, Transformation, Nachfolge." },
            { title: "Finanzsteuerung & Performance", desc: "Budget, Kennzahlen und Reporting: Margen, Liquidität und Ziele unter Kontrolle." },
          ],
        },
        {
          type: "text",
          theme: "dark",
          title: "Jedes Mandat beginnt mit Zuhören",
          paragraphs: [
            "Es endet mit einem schriftlichen, bezifferten und erklärten Plan. Sie wissen stets, warum jede Entscheidung empfohlen wird — und was sie kostet.",
            "Wir platzieren nie ein Produkt ohne dokumentierten Grund. Diese Regel leitet jedes Mandat seit der Gründung des Unternehmens.",
          ],
        },
        {
          type: "numbered",
          theme: "light",
          title: "Unsere Methode in vier Schritten",
          items: [
            { title: "Tätigkeitsdiagnose", desc: "Vollständiges, vertrauliches Audit: Tätigkeit, Organisation, Finanzen, Ziele und Marktrahmen." },
            { title: "Massgeschneiderte Strategie", desc: "Ein bezifferter, erklärter Aktionsplan, der vor jeder Umsetzung mit Ihnen validiert wird." },
            { title: "Umsetzung", desc: "Ausführung an Ihrer Seite, in voller Transparenz über Gebühren, Instrumente und Fristen." },
            { title: "Monitoring & Rebalancing", desc: "Mindestens ein jährliches Review — und Warnungen, sobald ein Markt- oder Lebensereignis die Lage ändert." },
          ],
        },
      ],
    },
  },
];
